export default __webpack_public_path__ + "static/media/Honored Leggings of the Four Winds.d500368a.jpg";